import React from 'react'
import isBoolean from 'lodash-es/isBoolean'
import { useTranslation } from 'react-i18next'
import { useFeatureFlags } from '@node-space/hooks'
import { Box, Switch } from '@node-space/ui-components'
import { useThemeContext } from 'hooks/context/useThemeContext'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'

export const DarkModeToggle = () => {
  const { t } = useTranslation()
  const { enableDarkMode } = useFeatureFlags()

  const { darkMode, setDarkMode } = useThemeContext()

  const toggleDarkMode = (checked: boolean) => {
    setDarkMode(checked)
    track.Amp.track(AmplitudeEvent.UPDATE_THEME_PREFERENCE, {
      category: AmplitudeEventCategory.APPLICATION,
      action: AmplitudeEventAction.CLICK,
      mode: checked ? 'dark' : 'light',
      system_preference: window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light',
    })
  }

  if (isBoolean(enableDarkMode) && !enableDarkMode) {
    return null
  }

  return (
    <Box flex align="center" gapX={8}>
      <Switch
        testId="dark-mode-toggle"
        aria-label={darkMode ? 'switch-to-light-mode' : 'switch-to-dark-mode'}
        value={Boolean(darkMode)}
        onChange={value => toggleDarkMode(value)}
      />
      <span className="text-body-regular text-foreground-prominent">{t('darkMode')}</span>
    </Box>
  )
}
